export default __webpack_public_path__ + "lroc_color_poles_2k.png";